import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  constructor(private http: HttpClient) { }

  getBanners(): Observable<any> {
    const payload = JSON.stringify({
      opr: 'Banner_Preview',
      sitio: 'TPQ'
    });
    
    const formData = new FormData();
    formData.append('payload', payload);

    return this.http.post(`${environment.URL_API}/gestionarLangingPage`, formData);
  }
}
